/**
 * Pre-compiled en messages for PasswordInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { hide: `Hide password`, show: `Show password` };
